

import { dbisHttp, bigDataHttp } from '@/utils/http/index.js'


/**
 * 获取异常订单统计
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16491
 */
 export function getExceptionDetail(data) {
  return dbisHttp.post('/dashboard/oms/exception_detail', data)
}

/**
 * 异常监控
 * https://yapi.ops.yunlizhi.cn/project/507/interface/api/16403
 */
 export function getExceptionStats(data) {
  return dbisHttp.post('/dashboard/oms/exception_stats', data)
}


/**
 * 温度异常监控
 * https://yapi.ops.yunlizhi.cn/project/507/interface/case/587
 */
 export function getTemperatureExceptionStats(data) {
  return dbisHttp.post('/dashboard/oms/temperature_exception_stats', data)
}

/**
 * 轨迹预警订单统计
 * https://yapi.ops.yunlizhi.cn/project/511/interface/api/17069
 */
 export function getOrderAlarm(data) {
  return bigDataHttp.post('/api/web/OMS/getUOrderAlarmCount', data)
}

/**
 * 轨迹预警订单列表
 * https://yapi.ops.yunlizhi.cn/project/511/interface/api/17103
 */
 export function getOrderAlarmList(data) {
  return bigDataHttp.post('/api/web/OMS/getUOrderAlarmList', data)
}


/**
 * 轨迹预警告警详情
 * https://yapi.ops.yunlizhi.cn/project/511/interface/api/17105
 */
 export function getAlarmByUOrder(data) {
  return bigDataHttp.post('/api/web/OMS/getAlarmByUOrder', data)
}